import { combineReducers } from "redux";
import tempPlaylist from './tempPlaylist';

export const rootReducer = combineReducers({
  tempPlaylist
});
